/**
 * @fileoverview PUT handler for the "/:app_group_id/conversational/tool_definition/:id" endpoint
 */
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { conversationalToolDefinitionIdCacheKeys } from "./constants";
import type {
  ConversationalToolDefinitionIdResult,
  UpdateConversationalToolDefinitionIdErrors,
  UpdateConversationalToolDefinitionIdProps,
} from "./types";

export const putConversationalToolDefinitionId = reactQueryMutationAdapter(
  conversationalToolDefinitionIdCacheKeys,
  createMutationFetcherFunctionWithShadowError<UpdateConversationalToolDefinitionIdErrors>()(
    (props: UpdateConversationalToolDefinitionIdProps): Promise<ConversationalToolDefinitionIdResult> => {
      return fetch(
        `/${props.appGroupId}/conversational/tool_definition/${props.definitionId}`,
        "PUT",
        {
          type: props.type,
          description: props.description,
          allowed_values: props.allowedValues,
        },
        undefined,
        {
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
